import {ApiCreateRuleRequestDto, ApiGetRulesResponseDto, ApiRuleResponseDto, ApiUpdateRuleRequestDto,} from '@birco/rainmesh-api';
import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {RuleFilter} from '../../../features/rules/state/rule.state';
import {HttpResponse} from '@angular/common/http';

export interface RuleStateService {

  getRules(options: RuleFilter): Observable<ApiGetRulesResponseDto>;

  getRuleById(options: { id: string }): Observable<ApiRuleResponseDto>;

  updateRule(options: { ruleId: string, requestDto: ApiUpdateRuleRequestDto }): Observable<ApiRuleResponseDto>;

  createRule(options: { requestDto: ApiCreateRuleRequestDto }): Observable<ApiRuleResponseDto>;

  deleteRule(options: { ruleId: string }): Observable<HttpResponse<any>>;

  updateIsActive(options: { id: string, isActive: boolean }): Observable<ApiRuleResponseDto>;
}

export const RULE_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<RuleStateService>('RuleStateService');
